export const endpointBase = "https://kdhkdsv558.execute-api.eu-central-1.amazonaws.com/dev";

export const personalPut = endpointBase + "/personal/put";
export const personalAcl = endpointBase + "/personal/acl";
export const tokenCostGet = endpointBase + "/token/cost/get";
export const freeTokenGet = endpointBase + "/token/free/get";
export const tokeInfoGet = endpointBase + "/token/info/get";

export const startIpx = endpointBase + "/token/ipx/start";
export const stopIox = endpointBase + "/token/ipx/stop";

